import { memoize } from '@util/lib/fast-memoize';

export function Memoize() {
  return function (_target: any, _propertyKey: string, descriptor: PropertyDescriptor) {
    const oldFunction = descriptor.value;
    const newFunction = memoize(oldFunction);

    descriptor.value = function () {
      // eslint-disable-next-line
      return newFunction.apply(this, arguments);
    };
  };
}
